// utils/prefetchLabs.js
import axios from "axios";
import { db } from "./offlineDB";
import { env } from "../constants/env";

export const prefetchLabs = async (token) => {
  if (!navigator.onLine) return;

  try {
    const res = await axios.get(`${env.kataApiUrl}/api/labs`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const labs = res.data;

    for (const lab of labs) {
      const localLab = await db.offlineLabs.get(lab._id);

      const serverUpdatedAt =
        lab.updatedAt || lab.createdAt || new Date(0).toISOString();

      // If local exists and is newer → keep local
      if (
        localLab &&
        (!localLab.lastSynced ||
          new Date(localLab.timestamp) >
            new Date(localLab.lastSynced) ||
          new Date(localLab.timestamp) > new Date(serverUpdatedAt))
      ) {
        console.log(
          `[PrefetchLabs] Keeping local lab ${lab.labName} (newer)`
        );
        continue;
      }

      // Safe to overwrite from server
      const labToSave = {
        ...lab,
        id: lab._id,
        offline: false,
        lastSynced: new Date().toISOString(),
        timestamp: Date.now(),
      };

      delete labToSave._id;

      await db.offlineLabs.put(labToSave);

      console.log(`[PrefetchLabs] Updated lab ${lab.labName} from server`);
    }

    console.log("Labs prefetch complete");
  } catch (err) {
    console.error("Failed to prefetch labs:", err.message);
  }
};